// import Parsley from 'parsleyjs';
// import cash from 'cash-dom';

(function($) {
	$(document).ready(function() {
		const $theList = $('#theList');

		// shows (added to window in content-list.php)
		const showSearchData = window.upcomingShows ? Object.values(window.upcomingShows) : [];

		// global vairables for filters/search
		let selectedVenue = $('#venueFilter').val();
		let searchedShows = null;

		$theList.on('eval-filters', function() {
			_handleFilters();
		});

		function _handleFilters() {
			_resetList();

			const hasSelectedVenue = selectedVenue && selectedVenue !== 'all';
			const hasSearchedShows = Boolean(searchedShows);

			if (hasSelectedVenue || hasSearchedShows) {
				if (hasSelectedVenue) {
					_hideByVenue(selectedVenue);
				}

				if (hasSearchedShows) {
					const ids = searchedShows.map(show => show.id);
					_hideByShowIds(ids);
				}

				_hasResults();
				_hideMobileAds();

        // hide date headers for each day section
        // when there are no shows showing in them
				$(".showlist-item:hidden")
          .closest('.show-date')
          .not( $(".showlist-item:visible")
          .closest('.show-date') )
          .hide();

        // document.querySelectorAll('.showlist-item').forEach(function(item) {
        //   if (item.style.display === 'none') {
        //     let closestDate = item.closest('.show-date');
        //     let isVisibleSibling = Array
        //       .from(closestDate.querySelectorAll('.showlist-item'))
        //       .some(function(sibling) {
        //         return sibling.style.display !== 'none';
        //       }
        //     );
        //     if (!isVisibleSibling) {
        //       closestDate.style.display = 'none';
        //     }
        //   }
        // });

				if ($('.showlist-item:hidden').length === showSearchData.length) {
					_noResults();
				}
			} else {
				_hasResults();
			}
		}

		// filters open
		$('.filters-btn').on('click', function() {
			$(this).toggleClass('closed');
			$('.filters-open-indicator').toggle();
      $('.filters-container').toggleClass('open');
		});

		// text search
		$('#show-search').on('input', function(e) {
			const theSearchString = $(this).val().toLowerCase() || '';

			if (!theSearchString.length || theSearchString.length < 3) {
				searchedShows = null;
				$theList.trigger('eval-filters');
				return;
			}

			const searchResults = showSearchData.filter(show => {
				return show.title.toLowerCase().includes(theSearchString);
			});

			searchedShows = searchResults;

			$theList.trigger('eval-filters');
		});

		$('.clear-all-filters').on('click', function() {
			_resetFilters();
			$theList.trigger('eval-filters');
		});

		function _resetFilters() {
			_clearSearch();
			_clearVenueFilter();
		}

		function _clearVenueFilter() {
			$('#venueFilter').val('all');
			selectedVenue = 'all';
		}

		function _clearSearch() {
			$('#show-search').val('');
			searchedShows = null;
		}

		function _noResults() {
			$('.title-section').hide();
			$('#noResults').show();

			_hideTopMessage();
		}

		function _hasResults() {
			$('.title-section').show();
			$('#noResults').hide();

			_hideTopMessage();
		}

		function _hideTopMessage() {
			$('.home-top-message').hide();
		}

		function _resetList() {
			$('.title-section').show();
			$('.showlist-item').show();
			$('.show-date').show();
			_showMobileAds();
		}

		function _hideMobileAds() {
			$('.mobile-ad').removeClass('d-flex').addClass('d-none');
		}

		function _showMobileAds() {
			$('.mobile-ad').removeClass('d-none').addClass('d-flex');
		}

		function _hideByVenue(venueName) {
			$('.showlist-item:not([data-venue="'+ venueName +'"])').hide();
		}

		// hide shows that don't match the showIds
		function _hideByShowIds(showIds) {
			const showsToHide = showSearchData.filter(show => {
				return !showIds.includes(show.id);
			});

			showsToHide.forEach(show => {
				$('.showlist-item[data-show-id="'+ show.id +'"]').hide();
			});
		}

		$(document).on('click', '.clear-search-btn', function() {
			_clearSearch();
			$theList.trigger('eval-filters');
		});

		// showlist venue filter
		$(document).on('change', '#venueFilter', function() {
			selectedVenue = $(this).val();
			$theList.trigger('eval-filters');

			if (site.env === 'production' && site.loggedIn !== '1') {
				gtag('event', 'click', {
					'event_category': 'filters',
					'event_label': 'venue selected',
					'event_value': selectedVenue,
					'send_to': 'UA'
				});

				gtag('event', 'click', {
					'click_type': 'filters',
					'click_action': 'venue selected',
					'click_value': selectedVenue,
					'send_to': 'GA4'
				});
			}
		});

		// Spotify Player

		// hide the spotify player when someone scrolls all the way to the bottom
		$(window).on('scroll', function() {
			if($(window).scrollTop() + $(window).height() == $(document).height()) {
				$('.spotify-action-btn, .spotify-wrapper').fadeOut('fast');
			} else {
				$('.spotify-action-btn, .spotify-wrapper').fadeIn('fast');
			}
		});

    // show spotify click trigger
    document.querySelector('.spotify-action-btn')?.addEventListener('click', function() {
      document.querySelector('.spotify-wrapper')?.classList.toggle('open');
    });

    // END - Spotify Player

    /**
     * Listens for use of the Tab key and adds a class to the body
     * to indicate that the user is tabbing. If user is tabbing we
     * add a class to the body that will disable the focus ring on
     * buttons and links.
     *
     * @param {object} e - The event object
     */
    function handleFirstTab(e) {
      if (e.keyCode === 9) { // tab key
        document.body.classList.add('user-is-tabbing');
        window.removeEventListener('keydown', handleFirstTab);
      }
    }
    window.addEventListener('keydown', handleFirstTab);

		// Scroll to top
		var sstButton = $('#ssttbutton'),
	      sstTimeout = false;

	  $(window).on('scroll', function() {
	    clearTimeout(sstTimeout);

	    if ($(this).scrollTop() < 500) {
	      sstButton.fadeOut();
	    } else {
	      sstButton.fadeIn();

	      sstTimeout = setTimeout(function() {
	        $('#ssttbutton') .fadeOut();
	      }, 1000);
	    }
	  });

	  $('#ssttbutton').on('click', function() {
	    $('html, body').animate({scrollTop:0}, 300);
	    return false;
	  });
		// END Scroll to top



		// GA Click Tracking
		if (site.env === 'production' && site.loggedIn !== '1') {
			document.querySelectorAll('.advertisement').forEach(item => {
				item.addEventListener('click', function() {
					gtag('event', 'click', {
						'event_category': 'ad',
						'event_label': this.dataset.adTitle,
						'send_to': 'UA'
					});

					gtag('event', 'click', {
						'click_type': 'advertisement',
						'click_action': 'ad (link)',
						'click_value': this.dataset.adTitle,
						'send_to': 'GA4'
					});
				});
			});

			document.querySelectorAll('.patreon-link').forEach(item => {
				item.addEventListener('click', function() {
					gtag('event', 'click', {
						'event_category': 'patreon',
						'event_label': 'patreon link',
						'send_to': 'UA'
					});

					gtag('event', 'click', {
						'click_type': 'patreon',
						'click_action': 'patreon link',
						'send_to': 'GA4'
					});
				});
			});

			document.querySelectorAll('.advertisement-no-link').forEach(item => {
				item.addEventListener('click', function() {
					gtag('event', 'click', {
						'event_category': 'ad (no link)',
						'event_label': this.dataset.adTitle,
						'send_to': 'UA'
					});

					gtag('event', 'click', {
						'click_type': 'advertisement',
						'click_action': 'ad (no link)',
						'click_value': this.dataset.adTitle,
						'send_to': 'GA4'
					});
				});
			});

			document.getElementById('spotify-playlist').addEventListener('click', function() {
				gtag('event', 'click', {
					'event_category': 'spotify player',
					'event_label': 'opened spotify player',
					'send_to': 'UA'
				});

				gtag('event', 'click', {
					'click_type': 'spotify player',
					'click_action': 'opened',
					'send_to': 'GA4'
				});
			});

			document.querySelectorAll('.filters-btn.closed').forEach(item => {
				item.addEventListener('click', function() {
					gtag('event', 'click', {
						'event_category': 'filters',
						'event_label': 'filters drawer opened',
						'send_to': 'UA'
					});

					gtag('event', 'click', {
						'click_type': 'filters',
						'click_action': 'opened',
						'send_to': 'GA4'
					});
				});
			});

			document.querySelectorAll('.show-link').forEach(item => {
				item.addEventListener('click', function() {
					gtag('event', 'click', {
						'event_category': 'shows',
						'event_label': 'show link',
						'event_value': this.dataset.showTitle,
						'send_to': 'UA'
					});

					gtag('event', 'click', {
						'click_type': 'show_listing',
						'click_action': 'show link',
						'click_value': this.dataset.showTitle,
						'send_to': 'GA4'
					});
				});
			});

			document.querySelectorAll('.venue-link').forEach(item => {
				item.addEventListener('click', function() {
					gtag('event', 'click', {
						'event_category': 'shows',
						'event_label': 'venue link',
						'event_value': this.dataset.venueTitle,
						'send_to': 'UA'
					});

					gtag('event', 'click', {
						'click_type': 'show_listing',
						'click_action': 'venue link',
						'click_value': this.dataset.venueTitle,
						'send_to': 'GA4'
					});
				});
			});

			document.querySelectorAll('.maps-link').forEach(item => {
				item.addEventListener('click', function() {
					gtag('event', 'click', {
						'event_category': 'shows',
						'event_label': 'map link',
						'event_value': this.dataset.venueTitle,
						'send_to': 'UA'
					});

					gtag('event', 'click', {
						'click_type': 'show_listing',
						'click_action': 'map link',
						'click_value': this.dataset.venueTitle,
						'send_to': 'GA4'
					});
				});
			});

			document.querySelectorAll('.social-link').forEach(item => {
				item.addEventListener('click', function() {
					gtag('event', 'click', {
						'event_category': 'social',
						'event_label': 'social link',
						'event_value': this.getAttribute('title'),
						'send_to': 'UA'
					});

					gtag('event', 'click', {
						'click_type': 'social',
						'click_action': 'social link',
						'click_value': this.getAttribute('title'),
						'send_to': 'GA4'
					});
				});
			});
    }
		// END GA Click Tracking

    /**
     * Triggers a CSS animation on a specified element.
     *
     * @param {string} element - The selector of the element to animate.
     * @param {string} animation - The animation name to apply.
     * @param {string} [prefix='animate__'] - The prefix to use for the animation classes.
     * @returns {Promise} A promise that resolves when the animation ends.
     *
     * @example
     * animateCSS('.my-element', 'fadeIn');
     *
     * @example
     * animateCSS('.my-element', 'bounce').then((message) => {
     *   // Do something after the animation
     * });
     */
    function _animateCSS(element, animation, prefix = 'animate__') {
      // We create a Promise and return it
      new Promise((resolve, reject) => {
        const animationName = `${prefix}${animation}`;
        const node = document.querySelector(element);

        node.classList.add(`${prefix}animated`, animationName);

        // When the animation ends, we clean the classes and resolve the Promise
        function handleAnimationEnd(event) {
          event.stopPropagation();
          node.classList.remove(`${prefix}animated`, animationName);
          resolve('Animation ended');
        }

        node.addEventListener('animationend', handleAnimationEnd, {once: true});
      });
    }

	});
})(jQuery);
